import store from '@/store'
import config from 'config'
import { Logger } from '@/lib/logger'

export const $t = (item: string, prefix = config.i18n.default_prefix, ...argvs: string[]) => {
  const translations = store.getters['LANG/getTranslations']
  if (translations[prefix] && translations[prefix][item]) {
    let translation = translations[prefix][item]
    let idx = 0
    for (idx; idx < argvs.length; idx++) {
      translation = translation.replace('%s', argvs[idx])
    }
    return translation
  }
  Logger.error(`Can't find translation for key: ${item} and prefix: ${prefix}`, 'i18n')()
  return item
}
